import { render, staticRenderFns } from "./IconSwitzerland.vue?vue&type=template&id=391fdee6&"
import script from "./IconSwitzerland.vue?vue&type=script&lang=ts&"
export * from "./IconSwitzerland.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports